import { bootstrapApplication } from '@angular/platform-browser';
import { KmhdRootPage } from './app/pages/app/root-page/root.page';
import { kmhdConfig } from './app/kmhd.config';

bootstrapApplication(KmhdRootPage, kmhdConfig).catch((err) =>
  console.error(err)
);
